import type {PortalProps} from './Portal'
import {Portal, registerPortalRoot} from './Portal'

export default Portal
export {registerPortalRoot}
export type {PortalProps}
